export class IngestionPipelineMetrics {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "observedAt",
            "baseName": "observedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "sourceRecordsPerSec",
            "baseName": "sourceRecordsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "sinkRecordsPerSec",
            "baseName": "sinkRecordsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceBytesPerSec",
            "baseName": "sourceBytesPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceTotalRecordsRead",
            "baseName": "sourceTotalRecordsRead",
            "type": "number",
            "format": ""
        },
        {
            "name": "sinkTotalRecordsWritten",
            "baseName": "sinkTotalRecordsWritten",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceBacklogRecords",
            "baseName": "sourceBacklogRecords",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceFilesPending",
            "baseName": "sourceFilesPending",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceOldestPendingAgeSeconds",
            "baseName": "sourceOldestPendingAgeSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "dlqMessages",
            "baseName": "dlqMessages",
            "type": "number",
            "format": ""
        },
        {
            "name": "invalidRecordsPerSec",
            "baseName": "invalidRecordsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "errorRate1hPct",
            "baseName": "errorRate1hPct",
            "type": "number",
            "format": ""
        },
        {
            "name": "secondsSinceLastCommit",
            "baseName": "secondsSinceLastCommit",
            "type": "number",
            "format": ""
        },
        {
            "name": "completedCheckpointsTotal",
            "baseName": "completedCheckpointsTotal",
            "type": "number",
            "format": ""
        },
        {
            "name": "lagSeconds",
            "baseName": "lagSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "lagSecondsP50",
            "baseName": "lagSecondsP50",
            "type": "number",
            "format": ""
        },
        {
            "name": "lagSecondsP95",
            "baseName": "lagSecondsP95",
            "type": "number",
            "format": ""
        },
        {
            "name": "percentileWindow",
            "baseName": "percentileWindow",
            "type": "string",
            "format": ""
        },
        {
            "name": "recordsIngested24h",
            "baseName": "recordsIngested24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "recordsIngested7d",
            "baseName": "recordsIngested7d",
            "type": "number",
            "format": ""
        },
        {
            "name": "sampledOutPct",
            "baseName": "sampledOutPct",
            "type": "number",
            "format": ""
        },
        {
            "name": "filteredOutPct",
            "baseName": "filteredOutPct",
            "type": "number",
            "format": ""
        },
        {
            "name": "samplingSubjectSharePct",
            "baseName": "samplingSubjectSharePct",
            "type": "number",
            "format": ""
        },
        {
            "name": "samplingRealizedKeepPct",
            "baseName": "samplingRealizedKeepPct",
            "type": "number",
            "format": ""
        },
        {
            "name": "samplingPolicyEpoch",
            "baseName": "samplingPolicyEpoch",
            "type": "number",
            "format": ""
        },
        {
            "name": "samplingSegmentsTracked",
            "baseName": "samplingSegmentsTracked",
            "type": "number",
            "format": ""
        },
        {
            "name": "samplingFlooredSegments",
            "baseName": "samplingFlooredSegments",
            "type": "number",
            "format": ""
        },
        {
            "name": "samplingSmallestTrackedCount",
            "baseName": "samplingSmallestTrackedCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "samplingUntrackedVolumeFraction",
            "baseName": "samplingUntrackedVolumeFraction",
            "type": "number",
            "format": ""
        },
        {
            "name": "samplingBootstrapActive",
            "baseName": "samplingBootstrapActive",
            "type": "number",
            "format": ""
        },
        {
            "name": "tableSizeBytes",
            "baseName": "tableSizeBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "tableMetadataBytes",
            "baseName": "tableMetadataBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "computeUsdPerHour",
            "baseName": "computeUsdPerHour",
            "type": "number",
            "format": ""
        },
        {
            "name": "computeNodeCount",
            "baseName": "computeNodeCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageUsdPerHour",
            "baseName": "storageUsdPerHour",
            "type": "number",
            "format": ""
        },
        {
            "name": "computeUsd24h",
            "baseName": "computeUsd24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageUsd24h",
            "baseName": "storageUsd24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageClassAOpsPerSec",
            "baseName": "storageClassAOpsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageClassBOpsPerSec",
            "baseName": "storageClassBOpsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageFreeOpsPerSec",
            "baseName": "storageFreeOpsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageApiUsdPerHour",
            "baseName": "storageApiUsdPerHour",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageApiUsd24h",
            "baseName": "storageApiUsd24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "jvmHeapUsedBytesMax",
            "baseName": "jvmHeapUsedBytesMax",
            "type": "number",
            "format": ""
        },
        {
            "name": "jvmHeapMaxBytesMax",
            "baseName": "jvmHeapMaxBytesMax",
            "type": "number",
            "format": ""
        },
        {
            "name": "lastCheckpointDurationMs",
            "baseName": "lastCheckpointDurationMs",
            "type": "number",
            "format": ""
        },
        {
            "name": "lastCheckpointSizeBytes",
            "baseName": "lastCheckpointSizeBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "failedCheckpointsTotal",
            "baseName": "failedCheckpointsTotal",
            "type": "number",
            "format": ""
        },
        {
            "name": "restartsTotal",
            "baseName": "restartsTotal",
            "type": "number",
            "format": ""
        },
        {
            "name": "backpressureMaxRatio",
            "baseName": "backpressureMaxRatio",
            "type": "number",
            "format": ""
        },
        {
            "name": "aggregations",
            "baseName": "aggregations",
            "type": "Array<IngestionPipelineAggregationMetrics>",
            "format": ""
        },
        {
            "name": "purges",
            "baseName": "purges",
            "type": "Array<IngestionPipelinePurgeMetrics>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineMetrics.attributeTypeMap;
    }
    constructor() {
    }
}
